import request from '@/router/axios';
let urlPrefix = '/api/exp/experimentreportmould';

export const add = (data = {}) => {
    return request(urlPrefix, { data }, 'post')
}

export const remove = id => {
    return request(`${urlPrefix}/${id}`, null, 'delete')
}

export const update = (data = {}) => {
    return request(urlPrefix, { data }, 'put')
}

export const getDetail = id => {
    return request(`${urlPrefix}/${id}`)
}

export const query = (page, limit, params) => {
    return request(`${urlPrefix}/query`, {
        params: {
            ...params,
            page,
            limit
        }
    })
}

/**
 * 获取可选择的报告模板（创建实验项目模板）
 */
export const getSelectReportMoulds = () => {
    return request(`${urlPrefix}/select`)
}

export const duplicateCheck = params => {
    return request(`${urlPrefix}/duplicateCheck`, {
        params
    });
}